import styles from './StreamerInfoContent.module.scss';
import clsx from 'clsx';
import ChannelRankInfo from './ChannelRank';
import SupportInfo from './SupportInfo';
import BroadCastInfo from './BroadCastInfo';
import ExternalLink from './ExternalLink';
import {useStationDashboardQuery} from '@/query/channel/station/useStationQuery';
import {isMobile} from 'react-device-detect';
import {useStationData} from '@/stores/channel/station';
import {useParams} from 'react-router-dom';

const StreamerInfoContent = () => {
  const {station} = useStationData();
  const {streamerId: streamerIdParam} = useParams();
  const {userId: streamerId} = station.detail || {};
  const {data: dashboard} = useStationDashboardQuery(
    streamerIdParam || streamerId!,
  );
  const isRank = dashboard?.rank && dashboard?.rank.length > 0;

  return (
    <div className={clsx(styles.InfoContent, !isRank && styles.user)}>
      <div className={styles.itemBox}>
        {/* 방송국순위 : 순위가 있는 경우 노출 */}
        {isRank && <ChannelRankInfo rankInfo={dashboard?.rank} />}
        {/* 후원정보 */}
        {dashboard?.upd && (
          <SupportInfo
            fanCount={dashboard?.upd.fanCount}
            fanclubCount={dashboard?.fanclubCount}
            supporterCount={dashboard?.supporterCount}
            subscriptionCount={dashboard?.subscription.total}
            tier1Count={dashboard?.subscription.tier1}
            tier2Count={dashboard?.subscription.tier2}
          />
        )}
      </div>
      <div className={styles.itemBox}>
        {/* 방송정보 */}
        {dashboard && <BroadCastInfo stationDashboard={dashboard} />}

        {/* 외부링크 */}
        {isMobile && (dashboard?.link.length || 0) > 0 && (
          <ExternalLink
            className={clsx({
              [styles.ExternalLink]: !isRank,
            })}
          />
        )}
      </div>
    </div>
  );
};

export default StreamerInfoContent;
